import { render, staticRenderFns } from "./ManageProcessingMethodsModal.vue?vue&type=template&id=bd4ad604&scoped=true"
import script from "./ManageProcessingMethodsModal.vue?vue&type=script&lang=js"
export * from "./ManageProcessingMethodsModal.vue?vue&type=script&lang=js"
import style0 from "./ManageProcessingMethodsModal.vue?vue&type=style&index=0&id=bd4ad604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4ad604",
  null
  
)

export default component.exports